import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { Button as ButtonV2, Heading } from '@restworld/ui-ds-base';

import { useCollaboratorActionModal } from '../../../collaborators.atoms';

import { cn } from '@restworld/utils-common';
function AddCollaboratorSuccessScreen() {
  const { t } = useTranslation('collaborators-page');
  const { closeCollaboratorActionModal } = useCollaboratorActionModal();

  return (
    <Wrapper>
      <CheckCircleIcon className="h-6 w-6 text-green-500" />
      <Heading color="neutral" className="text-lg lg:text-xl">
        {t('your_invite_has_been_sent')}
      </Heading>
      <ContentWrapper className="mb-1">
        {t('an_email_to_access_the_restworld_platform_has_been_sent_to_your_collaborator')}
      </ContentWrapper>
      <ContentWrapper>
        <TextWithEmphasis>{t('remember_to_check_your_spam_the_invitation_email_could_be_there')}</TextWithEmphasis>
        <ButtonV2 onClick={closeCollaboratorActionModal} fullwidth>
          {t('back_to_collaborators')}
        </ButtonV2>
      </ContentWrapper>
    </Wrapper>
  );
}
export default AddCollaboratorSuccessScreen;

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      // pb-8: ModalContent is noPadding, so without it the CTA sat almost flush against the modal's bottom edge.
      'h-full w-full max-w-[640px] mx-auto flex flex-col justify-center items-center gap-5 text-center pb-8',
      className
    )}
    {...props}
  />
);
const ContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('text-neutral-200 font-medium max-w-[576px]', className)} {...props} />
);
const TextWithEmphasis = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <strong className={cn('block mb-16', className)} {...props} />
);
